import { gql, useMutation } from '@apollo/client';
import { ISignatureRequest, SIGNATURE_REQUEST_FIELDS } from './useSignatureRequestCreateMutation';

const SIGN_SIGNATURE_REQUEST = gql`
  ${SIGNATURE_REQUEST_FIELDS}
  mutation SignSignatureRequest($image: String!, $token: String!) {
    signSignatureRequest(image: $image, token: $token) {
      ...SignatureRequestFields
    }
  }
`;

export interface SignSignatureRequestInput {
  image: string; // base64 encoded signature image
  token: string; // JWT token for authentication
}

export interface SignSignatureRequestResult {
  signSignatureRequest: ISignatureRequest;
}

export function useSignSignatureRequestMutation() {
  return useMutation<SignSignatureRequestResult, SignSignatureRequestInput>(SIGN_SIGNATURE_REQUEST, {
    update(cache, { data }) {
      if (!data?.signSignatureRequest) return;

      const updatedRequest = data.signSignatureRequest;

      // Update the signature request in the cache
      cache.writeFragment({
        id: cache.identify({ __typename: 'SignatureRequest', id: updatedRequest.id }),
        fragment: SIGNATURE_REQUEST_FIELDS,
        fragmentName: 'SignatureRequestFields',
        data: updatedRequest,
      });
    },
  });
}
